export default (props, e) => {
  e.preventDefault();
  const navToggle = document.getElementById('js_menuToggle');
  const navContainer = document.getElementById('js_navContainer');

  navToggle.classList.toggle('active');
  navContainer.classList.toggle('active');

  if (navToggle.getAttribute('aria-expanded') === true) {
    navToggle.setAttribute('aria-expanded', 'false');
  } else {
    navToggle.setAttribute('aria-expanded', 'true');
  }
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/webActions/menuToggle.js